import { Relationship, api } from '@wellesley/openapi'
import { RootState, AppDispatch } from '@wellesley/store'
import { memoize } from 'lodash/fp'

type OptimisticUpdateRelationsProps = {
  state: RootState
  userId: string
  dispatch: AppDispatch
  relationsProps: Partial<Relationship>
}

const query = 'getApiV1UsersRelationships'

const getMatchingArg = memoize((state: RootState, userId: string) => {
  const allArgs = api.util.selectCachedArgsForQuery(state, query)
  return allArgs.find((a) => a.targets.includes(userId))
})

const optimisticUpdateRelations = ({
  state,
  userId,
  dispatch,
  relationsProps,
}: OptimisticUpdateRelationsProps) => {
  const matchingArg = getMatchingArg(state, userId)

  if (!matchingArg) return null

  const patchResult = dispatch(
    api.util.updateQueryData(
      query,
      matchingArg,
      (draft: Record<string, Relationship>) => {
        draft[userId] = {
          ...draft[userId],
          ...relationsProps,
        }
      },
    ),
  )

  return patchResult
}

export default optimisticUpdateRelations
